/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TRemoveFromArchiveDesktopRequest,
  TRemoveFromArchiveDesktopModel,
  IMappers,
  TRemoveFromArchiveDesktopResponse,
  TRemoveFromArchiveDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createRemoveFromArchiveDesktopModel(
  parameters: TRemoveFromArchiveDesktopRequest,
): TRemoveFromArchiveDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/remove-from-archive-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IRemoveFromArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TRemoveFromArchiveDesktopRequest;
}

export async function fetchRemoveFromArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IRemoveFromArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TRemoveFromArchiveDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createRemoveFromArchiveDesktopModel(parameters),
    config,
  )) as FetchResponse<TRemoveFromArchiveDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TRemoveFromArchiveDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TRemoveFromArchiveDesktopResponse>;
}
